const ContextSourceOptions = require("%/dynamic-component-editor/classes/context-source-options");

const SOURCE_CONTEXT = "context";

// What an element needs bound, beside the entity it is bound to. A component
// element declares these; an action element's come from the event params its
// action sources from a context — same requirement, same binding map, different
// source of the list.
class ElementRequiredContexts {

  /** ******************* Public Static Methods *********************/

  // → [{ name, contextKey, entityType }]. `contextKey` is what the app's own
  // eventParams resolve by; the author binds `name` and never sees it.
  static forAction(entityType, appName, actionName, configsByApp, flat) {
    const entityConfig = ContextSourceOptions.resolveEntityConfig(entityType, appName, configsByApp, flat);
    const action = entityConfig?.actions?.[actionName];
    if (!action) {
      return [];
    }
    // An eventParam names the context it reads but carries no entity type —
    // the engine's sourceContextField schema has no key for one. The event the
    // action fires declares it, so that is where the type comes from; a
    // type on the param itself still wins where one is present.
    const eventParams = configsByApp?.[appName]?.events?.[action.eventName]?.params ?? {};
    const rows = [];
    for (const [paramName, sourceDef] of Object.entries(action.eventParams ?? {})) {
      if (sourceDef?.source !== SOURCE_CONTEXT) {
        continue;
      }
      rows.push({
        name: paramName,
        contextKey: sourceDef.context ?? paramName,
        entityType: sourceDef.entityType ?? eventParams[paramName]?.entityType ?? "",
      });
    }
    return rows;
  }

  // The contexts map an action fires with: the ambient scope, plus each bound
  // context re-keyed to what the app's eventParams resolve by.
  static applyBindings(contexts, rows, bindings) {
    const applied = { ...contexts };
    for (const row of rows) {
      const boundName = bindings?.[row.name];
      if (!boundName || !contexts?.[boundName]) {
        continue;
      }
      applied[row.contextKey] = contexts[boundName];
    }
    return applied;
  }

  static unbound(rows, bindings, contexts) {
    return rows
        .filter(row => !bindings?.[row.name] && !contexts?.[row.contextKey])
        .map(row => row.name);
  }

}

module.exports = ElementRequiredContexts;
